// Icon assets - exported as URL strings for Vite
// Assets are served from /public/icon/ directory

// Blockchain/Network icons
export const IcEthereum = "/icon/blockchain/ethereum.svg";
export const IcBSC = "/icon/blockchain/bsc.svg";
export const IcPolygonMatic = "/icon/blockchain/matic.svg";
export const IcOptimisticEthereum = "/icon/blockchain/optimistic-ethereum.svg";
export const IcArbitrumOne = "/icon/blockchain/arbitrum-one.svg";

// Wallet icons
export const IcMetamaskWallet = "/icon/wallet/ic-metamask-wallet.svg";
export const IcWalletConnect = "/icon/wallet/ic-wallet-connect.svg";
export const IcBrowserWallet = "/icon/wallet/ic-browser-wallet.svg";
export const IcWhiteConnectWallet = "/icon/wallet/ic-white-connect-wallet.svg";

// Social media icons
export const IcTwitterForm = "/icon/social/ic-twitter-form.svg";
export const IcFacebookForm = "/icon/social/ic-facebook-form.svg";
export const IcTelegramForm = "/icon/social/ic-telegram-form.svg";
export const IcDiscordForm = "/icon/social/ic-discord-form.svg";
export const IcLinkForm = "/icon/social/ic-link-form.svg";

// User/Profile icons
export const IcUserAdd = "/icon/user/ic-user-add.svg";
export const IcUserNotFollowed = "/icon/user/ic-user-not-followed.svg";
export const IcUserFollower = "/icon/user/ic-user-follower.svg";
export const IcFollowingPrimary = "/icon/user/ic-following-primary.svg";
export const IcUserAddFollow = "/icon/user/ic-user-add-follow.svg";
export const IcUserUnFollow = "/icon/user/ic-user-un-follow.svg";

// UI/Common icons
export const icPin = "/icon/ui/ic-pin.svg";
export const icWorld = "/icon/ui/ic-world.svg";
export const icRemovedNFT = "/icon/ui/ic-removed-nft.svg";
export const IcVerifiedImage = "/icon/ui/ic-verified-image.svg";
export const IcHandSpeaker = "/icon/ui/ic-hand-speaker.svg";

// Status/Confirmation icons
export const IcAvacusTick = "/icon/status/ic-avacus-tick.svg";
export const Ic24hActive = "/icon/status/ic-24h-active.svg";
export const IcApprovedSuccessfully =
  "/icon/status/ic-approved-successfully.svg";
export const IcDangerUserDenied = "/icon/status/ic-danger-user-denied.svg";
export const IcWarningUser = "/icon/status/ic-warning-user.svg";

// App Store icons
export const IcGooglePlay = "/icon/app-store/ic-google-play.svg";
export const IcAppleStore = "/icon/app-store/ic-apple-store.svg";

// Notification/Settings icons
export const IcBlackNormalMode = "/icon/notification/ic-black-normal-mode.svg";
export const IcDisabledJoin = "/icon/notification/ic-disabled-join.svg";
export const IcAirdropInfo = "/icon/notification/ic-airdrop-info.svg";

// Common/Misc icons
export const IcLogin = "/icon/common/ic-login.svg";
export const IcEnLanguage = "/icon/common/ic-en-language.png";
export const IcJpLanguage = "/icon/common/ic-jp-language.png";
export const IcGraySwap = "/icon/common/ic-gray-swap.svg";
export const IcGreenMultiUserPlus =
  "/icon/common/ic-green-multi-users-plus.svg";
export const IcGreenNormalMode = "/icon/common/ic-green-normal-mode.svg";
export const IcPartyChat = "/icon/common/ic-party-chat.svg";
export const IcPrimaryPartyChat = "/icon/common/ic-primary-party-chat.svg";
export const icSecureChat = "/icon/common/ic-secure-chat.svg";
export const IcBlackSecureChat = "/icon/common/ic-black-secure-chat.svg";
export const IcGroupChatType = "/icon/common/ic-group-chat-type.svg";
export const IcDirectMessages = "/icon/common/ic-direct-messages.svg";
export const IcGraySecureChat = "/icon/common/ic-gray-secure-chat.svg";
export const IcWhiteSecureChat = "/icon/common/ic-white-secure-chat.svg";
export const IcCreateGroup = "/icon/common/ic-create-group.svg";

// Secure Chat icons
export const IcMemberRequest = "/icon/secure-chat/ic-member-request.svg";
export const IcGroupAudience = "/icon/secure-chat/ic-group-audience.svg";
export const IcDemote = "/icon/secure-chat/ic-demote.svg";
export const IcPromote = "/icon/secure-chat/ic-promote.svg";
export const IcGroupChat = "/icon/secure-chat/ic-group-chat.svg";
